import React from "react";
import styled from "styled-components";
import { colors } from "./colors/color";
import { PropsWithChildren } from 'react';
import { amorgStyles } from './styles/amorgStyles';
import { CardVariantStyles } from './styles/cardStyles';
import { CardVariant, CardVariants } from "./Card";

type CardButtonProps = {
    variant?: CardVariant,
    marginTop?:number,
    marginBottom?:number,
    padding?: string,
    flex?:boolean,
    flexGrow?:string,
    style?: React.CSSProperties,
    disabled?: boolean,
    onClick?: () => void,
}

export function CardButton(props:PropsWithChildren<CardButtonProps>):JSX.Element
{
    const cardStyles = amorgStyles(colors).card;
    let variant = props.variant ?? 'light';
    if(!CardVariants.includes(variant))
        variant = 'light';

    const variantStyle:CardVariantStyles = cardStyles.variants[variant];

    function handleOnClick()
    {
        if(!props.disabled && props.onClick)
            props.onClick();
    }

    return <BaseCardButton role="button" tabIndex={0} variantStyle={variantStyle} {...props} onClick={handleOnClick}>{props.children}</BaseCardButton>;
}

const BaseCardButton = styled.div<{variantStyle:CardVariantStyles, marginTop?:number, marginBottom?:number, padding?: string, flex?:boolean, flexGrow?:string, disabled?:boolean, onClick?: () => void }>`
    margin-top:${props => props.marginTop===undefined ? '0px' : `${props.marginTop}px`};
    margin-bottom:${props => props.marginBottom===undefined ? '0px' : `${props.marginBottom}px`};
    padding:${props => props.padding ? props.padding : '1rem'};
    ${props => props.flex && "display: flex;" }
    ${props => props.flexGrow && `flex-grow: ${props.flexGrow};` }

    font-size: 16px;
    font-family: "Noto Sans", sans-serif;
    font-weight: 300;
    text-align: left;

    border-radius: ${props => amorgStyles(props.theme.colors).card.borderRadius};

    background-color: ${props => props.variantStyle.default.background};
    border: ${props => props.variantStyle.default.border};
    color: ${props => props.variantStyle.default.color};

    transition: all 0.2s ease-in;

    ${props => props.onClick && !props.disabled && `
        &:hover {
            background-color: ${props.variantStyle.hover.background};
            border: ${props.variantStyle.hover.border};
            color: ${props.variantStyle.hover.color};
            cursor: pointer;
        }
    `}

    &:active {
        background-color: ${props => props.variantStyle.active.background};
        border: ${props => props.variantStyle.active.border};
        color: ${props => props.variantStyle.active.color};
    }

    ${props => props.disabled && `
        background-color: ${props.variantStyle.disabled.background};
        border: ${props.variantStyle.disabled.border};
        color: ${props.variantStyle.disabled.color};
        cursor: not-allowed;
    `}
   
    & .list-menu li button div:hover{
        ${ props => props.onClick && "cursor: pointer;" }
    }
`;